// extracted by mini-css-extract-plugin
module.exports = {"articleTextLargeWrap":"article-text-large-wrap_articleTextLargeWrap__2E3dw"};